var MobileToggleShow = class {

    static modal;
    static btnShow;
    static btnHide;

    constructor(modal) {
        this.modal = modal;
        return this;
    }

    show() {
        this.modal.classList.remove("d-none");
        return this;
    }

    hide() {
        this.modal.classList.add("d-none");
        return this;
    }
};

module.exports = { MobileToggleShow };
